<ng-template #tableHeader>
  <div class="table-actions" *ngIf="!isReadonly">
    <nc-button [id]="buttonId" icon="add" [onClick]="openDialog"></nc-button>
    <nc-button [id]="downloadButtonId" *ngIf="!hideMultiDownload" icon="download" [onClick]="downloadSelected"
               [disabled]="!isAnySelected()"></nc-button>
  </div>
</ng-template>
<nc-datatable [id]="id"
              [tableHeader]="tableHeader"
              [columns]="columns"
              [data$]="data$"
              [selectConfig]="selectConfig"
              [rowClick]="edit"
              [filterConfig]="filterConfig">
</nc-datatable>
<div *ngIf="isInvalid()" class="documents-error">
  <ng-container *ngIf="getErrorMessage() as errorLabel">
    {{errorLabel.label | translate:errorLabel.parameters }}
  </ng-container>
</div>
<a #downloadLink [hidden]="true"></a>
